import { connect } from 'react-redux'
import { Img } from './Image.jsx'
import { getCurrentMediaProps } from '../../../../redux/mediaList/selectors'
import {
    isInvertActive,
    getFilters,
    areFiltersApplied,
} from '../../../../redux/appliedFilters/selectors'
import {
    initImageRect,
    initProjection,
    keepImageInBoundaries,
    updateImageReferencePosition,
} from '../../../../redux/canvas/actions'
import {
    computeViewData,
    getScale,
    isImageReadyToBeDisplayed,
} from '../../../../redux/canvas/selectors'
import {
    currentMediaSourceLoaded,
    currentMediaSourceLoading,
    currentMediaSourceUnloaded,
    unableToLoadCurrentMedia,
} from '../../../../redux/currentMedia/actions'
import {
    zoomInRelativeToPointerPosition,
    zoomOutRelativeToPointerPosition,
} from '../../../../redux/appliedFilters/actions'
import { isCollaborativeIndexationCreationSelectionToolActive } from '../../../../redux/collaborativeIndexations/selectors'


const mapStateToProps = (state, props) => ({
    ...getCurrentMediaProps(state),
    isInvertActive: isInvertActive(state),
    filters: getFilters(state),
    computeViewData: () => computeViewData(state, props.id),
    areFiltersApplied: areFiltersApplied(state),
    scaleFactor: getScale(state, props.id),
    isInteractive: (props.isInteractive || false) && ! isCollaborativeIndexationCreationSelectionToolActive(state),
    isImageReadyToBeDisplayed: isImageReadyToBeDisplayed(state, props.id),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    initImageRect: (width, height) => dispatch(initImageRect(width, height)),
    initProjection: () => dispatch(initProjection(ownProps.id, ownProps.frame, 0, ownProps.viewScale)),
    sourceLoading: () => dispatch(currentMediaSourceLoading(ownProps.id)),
    sourceLoaded: () => dispatch(currentMediaSourceLoaded(ownProps.id)),
    unableToLoadMedia: () => dispatch(unableToLoadCurrentMedia()),
    keepImageInBoundaries: () => dispatch(keepImageInBoundaries(ownProps.id)),
    zoomIn: (pointerPosition) => dispatch(zoomInRelativeToPointerPosition(pointerPosition, ownProps.id)),
    zoomOut: (pointerPosition) => dispatch(zoomOutRelativeToPointerPosition(pointerPosition, ownProps.id)),
    updateImageReferencePosition: (scaleFactor, vector) => dispatch(updateImageReferencePosition(scaleFactor, vector)),
    onUnmount: () => dispatch(currentMediaSourceUnloaded(ownProps.id))
})

export const ImageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    undefined,
    { withRef: true }
)(Img)
